import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { Toaster } from '@aitoken/ui/components/sonner';
import { TooltipProvider } from '@aitoken/ui/components/tooltip';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setCsrfToken } from './lib/api';
import { queryClient, setUnauthenticatedHandler, wasToasted } from './lib/query-client';
import { createAppRouter } from './router';
import './styles.css';

const router = createAppRouter(queryClient);

// 会话过期：清空缓存并回到登录页（带上当前地址，登录后返回）
let redirecting = false;
setUnauthenticatedHandler(() => {
  if (redirecting || router.state.location.pathname === '/login') return;
  redirecting = true;
  setCsrfToken(null);
  queryClient.clear();
  void router.navigate({ to: '/login', search: { redirect: router.state.location.href } }).finally(() => {
    redirecting = false;
  });
});

// 已经以 toast 呈现的接口错误（例如确认弹窗内的提交失败）不再作为未处理异常输出
window.addEventListener('unhandledrejection', (event) => {
  if (wasToasted(event.reason)) event.preventDefault();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={300}>
        <RouterProvider router={router} />
      </TooltipProvider>
      <Toaster position="bottom-right" closeButton richColors={false} />
    </QueryClientProvider>
  </StrictMode>,
);
